import { ref } from "firebase/database";
import database from ".";

export const getTypingRef = (conversationId: string, userId: string) => {
  return ref(database, `/typing/${conversationId}_${userId}`);
};
